import { opacityDisappear } from 'avif-comparison/src/components/AppModal';
import { opacityAppear } from 'components/Home';
import CompanyNavList from 'components/NewHeader/CompanyNavList';
import ProductNavList from 'components/NewHeader/ProductNavList';

import React, { Dispatch, SetStateAction } from 'react';
import { useAnimation } from 'shared-utils';
import styled, { css } from 'styled-components';
import { Submenus } from '.';

type Props = {
  submenuType: Submenus;
  setSubmenuType: Dispatch<SetStateAction<Submenus>>;
};

const SubMenus = ({ submenuType, setSubmenuType }: Props) => {
  const [isVisible, showAnimation] = useAnimation(submenuType !== null, 150);

  if (!isVisible && !showAnimation) return null;

  return (
    <SubMenusContainer
      showAnimation={showAnimation}
      onMouseOver={() => {
        setSubmenuType(submenuType);
      }}
      onMouseLeave={() => setSubmenuType(null)}
    >
      <div
        className="inner-wrapper"
        style={{ minHeight: submenuType === 'company' ? '164px' : '396px' }}
      >
        <div className="panel" data-open={submenuType === 'company'}>
          <CompanyNavList />
        </div>
        <div className="panel" data-open={submenuType === 'product'}>
          <ProductNavList />
        </div>
      </div>
    </SubMenusContainer>
  );
};

export default SubMenus;

type SubMenusContainerProps = {
  showAnimation: boolean;
};

const SubMenusContainer = styled.div<SubMenusContainerProps>`
  position: absolute;
  z-index: 999;
  top: 100%;
  left: 0;
  right: 0;
  animation: ${opacityAppear} 0.15s ease-in;

  ${({ showAnimation }) =>
    showAnimation &&
    css`
      animation: ${opacityDisappear} 0.15s ease-in;
    `}

  .inner-wrapper {
    width: 968px;
    margin: 0 auto;
    border-radius: 16px;
    background: #fff;
    box-shadow: 0 4px 8px 2px rgba(0, 0, 0, 0.12);

    position: relative;
    transition: min-height 200ms ease;
  }
  .panel {
    padding: 24px 48px;
    position: absolute;
    inset: 0;
    opacity: 0;
    transform: translateY(8px);
    transition: opacity 150ms ease, transform 150ms ease, visibility 150ms;
    visibility: hidden;
    pointer-events: none;
    will-change: opacity, transform;
  }
  .panel[data-open='true'] {
    opacity: 1;
    transform: translateY(0);
    visibility: visible;
    pointer-events: auto;
  }
  @media screen and (max-width: 1048px) {
    display: none;
  }
`;
